export default __webpack_public_path__ + "static/media/sendInvoice-icon.b7a47247.svg";